import PropTypes from 'prop-types'
import React from 'react'
import * as ModelApi from '../services/api/modelsApi'

const ModelsStateContext = React.createContext()
const ModelsDispatchContext = React.createContext()

const modelsReducer = (state = {}, action) => {
  switch (action.type) {
    case 'GET':
      return {
        ...state,
        models: [],
        settings: { canUseExternalHSM: false, loading: false },
        loading: true,
        errors: [],
        error: false,
      }
    case 'GET_RECEIVED':
      return {
        ...state,
        models: action.models,
        totalPages: action.totalPages,
        pageNumber: action.pageNumber,
        itemsPerPage: action.itemsPerPage,
        loading: false,
        errors: [],
        error: false,
      }
    case 'GET_REQUEST_FAILURE':
      return {
        ...state,
        models: [],
        loading: false,
        openMessage: true,
        message: 'Falha ao buscar modelos',
        errors: ['Falha ao buscar modelos'],
        error: true,
      }
    case 'GET_PHONE_NUMBERS':
      return { ...state, phoneNumbers: [], errors: [], error: false }
    case 'GET_PHONE_NUMBERS_RECEIVED':
      return { ...state, phoneNumbers: action.phoneNumbers, errors: [], error: false }
    case 'GET_PHONE_NUMBERS_FAILURE':
      return {
        ...state,
        phoneNumbers: [],
        loading: false,
        openMessage: true,
        message: 'Falha ao listar número dos telefones',
        errors: ['Falha ao listar número dos telefones'],
        error: true,
      }
    case 'ADD':
      return { ...state, errors: [], error: false }
    case 'ADD_SUCCESS':
      return {
        ...state,
        openMessage: true,
        message: 'O modelo de mensagem foi criado e encaminhado para aprovação da Meta.',
        errors: [],
        error: false,
      }
    case 'ADD_FAILURE':
      return {
        ...state,
        openMessage: true,
        message: 'Falha ao criar seu modelo de mensagem',
        errors: ['Falha ao criar seu modelo de mensagem'],
        error: true,
      }
    case 'ADD_MODEL_SUCCESS':
      return {
        ...state,
        openMessage: true,
        message: 'O modelo de mensagem foi criado e encaminhado para aprovação da Meta.',
        errors: [],
        error: false,
      }
    case 'ADD_MODEL_FAILURE':
      return {
        ...state,
        openMessage: true,
        message: 'Falha ao salvar seu modelo de mensagem',
        errors: action.errors,
        error: true,
      }
    case 'REMOVE':
      return { ...state, error: false, errors: [] }
    case 'REMOVE_SUCCESS':
      return {
        ...state,
        models: state.models.filter((model) => model.id !== action.id),
        openMessage: true,
        message: 'Seu modelo de mensagem foi removido',
        errors: [],
        error: false,
      }
    case 'REMOVE_FAILURE':
      return {
        ...state,
        openMessage: true,
        message: 'Falha ao deletar seu modelo de mensagem',
        errors: ['Falha ao deletar seu modelo de mensagem'],
        error: true,
      }
    case 'CLOSE_MESSAGE':
      return { ...state, openMessage: false, message: '', error: false, errors: [] }
    case 'UPLOAD':
      return { ...state, fileName: action.fileName, loading: true, fileUploadedError: [], error: false, errors: [] }
    case 'UPLOAD_SUCCESS':
      return {
        ...state,
        fileId: action.fileId,
        fileName: action.fileName,
        fileType: action.fileType,
        loading: false,
        fileUploadedError: [],
        errors: [],
        error: false,
      }
    case 'UPLOAD_FAILURE':
      return {
        ...state,
        fileUploadedError: action.errors,
        fileName: '',
        loading: false,
        errors: action.errors,
        error: true,
      }
    case 'CANCEL_UPLOAD':
      return { ...state, fileName: '', fileUploadedError: [], fileId: '', fileType: '', errors: [], error: false }
    case 'GET_SETTINGS':
      return { ...state, settings: { ...action.settings, loading: true }, errors: [], error: false }
    case 'GET_SETTINGS_RECEIVED':
      return {
        ...state,
        settings: { ...action.settings, loading: false },
        loading: false,
        errors: [],
        error: false,
      }
    case 'GET_SETTINGS_FAILURE':
      return {
        ...state,
        settings: { ...action.settings, loading: false },
        loading: false,
        openMessage: true,
        message: 'Falha ao buscar as configurações',
        errors: ['Falha ao buscar as configurações'],
        error: true,
      }
    case 'GET_BUSINESS_ACCOUNTS':
      return { ...state, accounts: [], errors: [], error: false }
    case 'GET_BUSINESS_ACCOUNTS_RECEIVED':
      return { ...state, accounts: action.accounts, loading: false, errors: [], error: false }
    case 'GET_BUSINESS_ACCOUNTS_FAILURE':
      return {
        ...state,
        accounts: [],
        loading: false,
        openMessage: true,
        message: 'Falha ao listar contas',
        errors: ['Falha ao listar contas'],
        error: true,
      }
    case 'GET_TEMPLATES':
      return {
        ...state,
        templates: [],
        settings: { ...state.settings, loading: false },
        loading: true,
        errors: [],
        error: false,
      }
    case 'GET_TEMPLATES_RECEIVED':
      return {
        ...state,
        templates: action.templates,
        totalPages: action.totalPages,
        totalItems: action.totalItems,
        pageNumber: action.pageNumber,
        pageSize: action.pageSize,
        loading: false,
        errors: [],
        error: false,
      }
    case 'GET_TEMPLATES_FAILURE':
      return {
        ...state,
        templates: [],
        loading: false,
        openMessage: true,
        message: 'Falha ao buscar os templates',
        errors: ['Falha ao buscar os templates'],
        error: true,
      }
    case 'SET_TEMPLATE_ITEM':
      return {
        ...state,
        template: action.template,
      }
    case 'UNSET_TEMPLATE_ITEM':
      return {
        ...state,
        template: null,
      }
    case 'TOGGLE_DELETE_CONFIRMED_MODAL':
      return {
        ...state,
        showDeleteConfirmedModal: action.deleteConfirmedModal,
      }
    case 'TOGGLE_HIDE_MODAL':
      return {
        ...state,
        showHideModal: action.hideModal,
      }
    default:
      return {
        ...state,
        models: [],
        template: null,
        phoneNumbers: [],
        pageNumber: 1,
        totalPages: 1,
        itemsPerPage: 10,
        loading: false,
        errors: [],
        error: false,
        showDeleteConfirmedModal: false,
        showHideModal: false,
      }
  }
}

function ModelProvider({ children }) {
  const [state, dispatch] = React.useReducer(modelsReducer, {})
  return (
    <ModelsStateContext.Provider value={state}>
      <ModelsDispatchContext.Provider value={dispatch}>{children}</ModelsDispatchContext.Provider>
    </ModelsStateContext.Provider>
  )
}

function getModels(dispatch, pageNumber = 1, itemsPerPage = 10, content = null, initialDate, finalDate) {
  dispatch({ type: 'GET' })
  ModelApi.get({ pageNumber, itemsPerPage, content, initialDate, finalDate })
    .then((data) => {
      dispatch({
        type: 'GET_RECEIVED',
        models: data.data.template,
        totalPages: data.data.pages,
        pageNumber,
        itemsPerPage: data.data.template.length < 10 ? 10 : data.data.template.length,
      })
    })
    .catch((error) => {
      dispatch({ type: 'GET_REQUEST_FAILURE' })
      console.error(error)
    })
}

function getTemplates(dispatch, wabaId, pageNumber = 0, pageSize = 10) {
  dispatch({ type: 'GET_TEMPLATES' })
  ModelApi.getTemplates({ wabaId, pageNumber, pageSize })
    .then((data) => {
      dispatch({
        type: 'GET_TEMPLATES_RECEIVED',
        templates: data.data.items,
        totalPages: data.data.totalPages,
        totalItems: data.data.totalItems,
        pageNumber,
        pageSize,
      })
    })
    .catch((error) => {
      dispatch({ type: 'GET_TEMPLATES_FAILURE' })
      console.error(error)
    })
}

function setTemplatesList({ dispatch, data, pagination: { pageNumber, pageSize } }) {
  dispatch({
    type: 'GET_TEMPLATES_RECEIVED',
    templates: data.data,
    totalPages: data.pageSize,
    totalItems: data.totalRecords,
    pageNumber,
    pageSize,
  })
}

function setTemplateItem({ dispatch, data }) {
  dispatch({
    type: 'SET_TEMPLATE_ITEM',
    template: data,
  })
}
function unsetTemplateItem({ dispatch }) {
  dispatch({
    type: 'UNSET_TEMPLATE_ITEM',
  })
}

function showDeleteConfirmedModal({ dispatch, value }) {
  dispatch({
    type: 'TOGGLE_DELETE_CONFIRMED_MODAL',
    deleteConfirmedModal: value,
  })
}
function showHideModal({ dispatch, value }) {
  dispatch({
    type: 'TOGGLE_HIDE_MODAL',
    hideModal: value,
  })
}

function getSettings(dispatch) {
  dispatch({ type: 'GET_SETTINGS' })
  ModelApi.getSettings()
    .then((data) => {
      dispatch({
        type: 'GET_SETTINGS_RECEIVED',
        settings: data.data,
      })
    })
    .catch(() => {
      dispatch({ type: 'GET_SETTINGS_FAILURE' })
    })
}

function getPhoneNumbers(dispatch) {
  dispatch({ type: 'GET_PHONE_NUMBERS' })
  ModelApi.getPhoneNumbers()
    .then((data) => {
      dispatch({ type: 'GET_PHONE_NUMBERS_RECEIVED', phoneNumbers: data.data })
    })
    .catch(() => {
      dispatch({ type: 'GET_PHONE_NUMBERS_FAILURE' })
    })
}

function addModel(dispatch, payload) {
  return ModelApi.create(payload)
    .then(() => {
      dispatch({ type: 'ADD_SUCCESS' })
    })
    .catch(() => {
      dispatch({ type: 'ADD_FAILURE' })
    })
}

function addExternalModel(dispatch, payload) {
  return ModelApi.createExternalTemplate(payload)
    .then((response) => response.json())
    .then((response) => {
      if (response?.status === 'NOTVALID' || response?.status === 'ERROR') {
        dispatch({ type: 'ADD_MODEL_FAILURE', errors: response.errors })
      } else {
        dispatch({ type: 'ADD_MODEL_SUCCESS' })
      }
      return response
    })
    .catch((err) => {
      dispatch({ type: 'ADD_MODEL_FAILURE', errors: [err.message || 'Houve um erro inesperado. Tente novamente!'] })
    })
}

function editExternalModel(dispatch, payload) {
  return ModelApi.editExternalTemplate(payload)
    .then((response) => {
      if (response?.ok && response?.status === 200) {
        return {
          status: 'SUCCESS',
        }
      }
      return response?.json()
    })
    .then((response) => {
      if (response?.status === 'NOTVALID' || response?.status === 'ERROR') {
        dispatch({ type: 'ADD_MODEL_FAILURE', errors: response.errors })
      } else {
        dispatch({ type: 'ADD_MODEL_SUCCESS' })
      }
      return response
    })
    .catch((error) => {
      dispatch({ type: 'ADD_MODEL_FAILURE', errors: [error.message || 'Houve um erro inesperado. Tente novamente!'] })
    })
}

function deleteModel(dispatch, id) {
  ModelApi.remove(id)
    .then(() => {
      dispatch({ type: 'REMOVE_SUCCESS', id })
    })
    .catch(() => {
      dispatch({ type: 'REMOVE_FAILURE' })
    })
}

function closeMessage(dispatch) {
  dispatch({ type: 'CLOSE_MESSAGE' })
}

function uploadFile(dispatch, payload) {
  dispatch({ type: 'UPLOAD', fileName: payload.name })
  const formData = new FormData()
  formData.append('file', payload, payload.name)

  ModelApi.uploadFile(formData)
    .then((data) => {
      if (data.data.validations) {
        dispatch({ type: 'UPLOAD_FAILURE', errors: data.data.validations })
      } else {
        dispatch({ type: 'UPLOAD_SUCCESS', fileId: data.data, fileName: payload.name, fileType: payload.type })
      }
    })
    .catch((error) => {
      if ('message' in error) {
        dispatch({ type: 'UPLOAD_FAILURE', errors: [error.message] })
      } else {
        dispatch({ type: 'UPLOAD_FAILURE', errors: error.data.validations })
      }
    })
}

function cancelUpload(dispatch) {
  dispatch({ type: 'CANCEL_UPLOAD' })
}

function getBusinessAccounts(dispatch) {
  dispatch({ type: 'GET_BUSINESS_ACCOUNTS' })
  ModelApi.getBusinessAccounts()
    .then((data) => {
      dispatch({ type: 'GET_BUSINESS_ACCOUNTS_RECEIVED', accounts: data.data })
    })
    .catch(() => {
      dispatch({ type: 'GET_BUSINESS_ACCOUNTS_FAILURE' })
    })
}

function useModelDispatch() {
  const context = React.useContext(ModelsDispatchContext)
  if (context === undefined) {
    throw new Error(`ModelsDispatchContext must be used within a ModelProvider`)
  }
  return context
}

function useModelState() {
  const context = React.useContext(ModelsStateContext)
  if (context === undefined) {
    throw new Error(`ModelsStateContext must be used within a ModelProvider`)
  }
  return context
}

ModelProvider.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
}

export {
  addExternalModel,
  addModel,
  cancelUpload,
  closeMessage,
  deleteModel,
  editExternalModel,
  getBusinessAccounts,
  getModels,
  getPhoneNumbers,
  getSettings,
  getTemplates,
  ModelProvider,
  modelsReducer,
  setTemplateItem,
  setTemplatesList,
  showDeleteConfirmedModal,
  showHideModal,
  unsetTemplateItem,
  uploadFile,
  useModelDispatch,
  useModelState
}

